import { Alert } from "@mui/lab";
import { Stack, Typography } from "@mui/material";
import React from "react";
import type { Rental, RentalWarningResult } from "../../../domain/rental";

interface Props {
  result: RentalWarningResult;
  rental: Rental;
}

export const RentalsItemWarningResult = ({ result, rental }: Props) => {
  return (
    <Stack spacing={2}>
      {result.emailStatus === "SUCCESS" && (
        <Alert severity="success">
          The warning email was sent successfully
        </Alert>
      )}
      {result.emailStatus === "FAILURE" && (
        <Alert severity="error">
          The warning email wasn't sent successfully
        </Alert>
      )}
      {result.emailStatus === "NOT_STATED" && (
        <Alert severity="info">We didn't try to send the warning email</Alert>
      )}

      {!!result.errorMessages.length && (
        <Typography color="error">Errors</Typography>
      )}

      {result.errorMessages.map((error) => {
        return (
          <Alert severity="error" key={error}>
            {error}
          </Alert>
        );
      })}
    </Stack>
  );
};
